import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import {
  Stack,
  Paper,
  Button,
  Container,
  Typography,
  Grid,
  CircularProgress,
  Box,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

import { AddClientNotes, DeleteClientNotes, EditClientNotes, GetClient } from 'src/components/services/httpServices';
import ModalLayout from 'src/theme/Modal';
import { Trash } from 'react-feather';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function ClientNotesList(props) {
  let { id, checkClient } = useParams();
  const navigate = useNavigate();

  const [client, setClient] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');

  const notesRef = useRef('');
  const fetchClient = async (event) => {
    let savedclient = await GetClient(id);
    setClient(savedclient);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const CreateClientNotes = async (event) => {
    // setPosting(true);
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      description: notesRef.current.value,
      mstClientId: id,
    };

    //console.log(payload);
    let response = await AddClientNotes(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.mstNotes = response.data;
      setClient(clientSaved);
      // setTimeout(() => {
      //   navigate(`/app/EditClient/${response.data.id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const deleteNotes = async (rowId) => {
    setLoading(true);
    event.preventDefault();
    let response = await DeleteClientNotes(rowId);
    //console.log('RRRRR', response);
    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Notes saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.mstNotes = response.data;
      setClient(clientSaved);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  return (
    <>
      <form onSubmit={CreateClientNotes}>
        <Helmet>
          <title> Clients | Immigration System </title>
        </Helmet>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom></Typography>

          <Stack direction="row" spacing={2}>
            {/* <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button> */}
            <Button type="submit" variant="contained">
              Save
            </Button>
          </Stack>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={12}>
                    <TextField
                      label="Notes"
                      multiline
                      rows={4}
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={notesRef}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <br></br>
              <br></br>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr#</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Added Date</TableCell>
                      <TableCell>Added By</TableCell>

                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {client?.mstNotes?.map((row, index) => (
                      <TableRow key={index + 1}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.description}</TableCell>
                        <TableCell>{row.createDate?.split('T')[0]}</TableCell>
                        <TableCell>{row.createdBy}</TableCell>

                        <TableCell>
                          <ModalLayout
                            component={<Trash />}
                            description="Are You Sure you want to Delete?"
                            Hit={() => deleteNotes(row.id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
}
